export enum MaterialIconSize {
  DEFAULT = 'default',
  SIZE_14 = '14',
  SIZE_16 = '16',
  SIZE_18 = '18',
  SIZE_20 = '20',
  SIZE_24 = '24',
  SIZE_36 = '36'
}
